// extracted by mini-css-extract-plugin
export default {"container":"carrousel_container__I769l","item":"carrousel_item__R+DSv"};